/* ============================================================
   Duvarinda Gor  (6 Eylul 2026)

   Codex'in "farklilastirici fikirler" listesindeki madde; adi
   DECISIONS.md'de sabitlendi: "Duvarinda Gor" ("Duvarini Provala" DEGIL).
   Musteri kendi duvarinin fotografini yukler, cerceveli poster uzerine
   bindirilir; surukleyerek yerini, kaydiricyla boyutunu ayarlar.

   TAMAMEN TARAYICIDA CALISIR. Duvar fotografi hicbir yere gonderilmez,
   sunucuya yuklenmez, sepete/siparise eklenmez -- yalniz bu sekmede,
   bellekte durur ve pencere kapaninca gider.

   POSTER GORSELI NEREDEN GELIYOR
   ------------------------------
   1) Tasarimci sayfasindaysak (`[data-cp-canvas]` var): musterinin O ANDA
      tuvalde yaptigi tasarim kullanilir; cerceve burada koda ciziliyor
      (pipeline.render_flat_frame ile ayni oran: kalinlik = genisligin %5'i).
   2) Normal urun sayfasinda: urunun kapak fotografi kullanilir. Ama o
      fotograf 1600x1600 KARE bir studyo zemini uzerinde duruyor (bkz.
      pipeline.FRAME_CANVAS / FRAME_FIT); oldugu gibi duvara yapistirilirsa
      posterin etrafinda krem bir kare gorunurdu. Bu yuzden cerceveli poster
      OTOMATIK KIRPILIYOR: goruntudeki cok koyu pikseller (siyah cerceve,
      max kanal < 110) taranip sinirlari bulunuyor. Golge bu esigin altinda
      kaldigi icin kirpima girmiyor.
      Kirpma basarisiz olursa once zemin-farki yontemi, o da olmazsa
      gorselin tamami kullaniliyor -- ozellik hicbir durumda kirilmiyor.

   Piksel okumasi cross-origin: Shopify CDN `Access-Control-Allow-Origin: *`
   gonderdigi icin `crossOrigin="anonymous"` ile tuval kirlenmiyor
   (tarayicida dogrulandi). Yine de tum okuma try/catch icinde.
   ============================================================ */
(function () {
  "use strict";

  var KIRPMA_ONBELLEK = {};

  document.addEventListener("DOMContentLoaded", function () {
    var root = document.querySelector("[data-dg-root]");
    if (!root) return;

    var trigger = root.querySelector("[data-dg-open]");
    var modal = root.querySelector("[data-dg-modal]");
    var stage = root.querySelector("[data-dg-stage]");
    var wall = root.querySelector("[data-dg-wall]");
    var poster = root.querySelector("[data-dg-poster-img]");
    var drop = root.querySelector("[data-dg-drop]");
    var dosya = root.querySelector("[data-dg-file]");
    var tools = root.querySelector("[data-dg-tools]");
    var slider = root.querySelector("[data-dg-size]");
    var degistir = root.querySelector("[data-dg-change]");
    var hata = root.querySelector("[data-dg-error]");
    if (!trigger || !modal || !stage || !wall || !poster || !dosya) return;

    var acanOge = null;
    var duvarUrl = null;

    // --- Dugmeyi gorsel galerinin hemen altina tasi (varsa).
    // Horizon'da galeri <media-gallery>. Bulunamazsa dugme bolumun kendi
    // yerinde kalir; yani tasima basarisiz olsa bile ozellik gorunur olur.
    try {
      var galeri = document.querySelector("media-gallery");
      if (galeri && galeri.parentNode) galeri.parentNode.insertBefore(root, galeri.nextSibling);
    } catch (e) { /* yerinde kalsin */ }

    // ---------------------------------------------------------------
    // Poster gorseli
    // ---------------------------------------------------------------
    function tasarimciTuvali() {
      var adaylar = document.querySelectorAll("[data-cp-canvas]");
      for (var i = 0; i < adaylar.length; i++) {
        var c = adaylar[i];
        if (c.width > 10 && c.height > 10 && c.offsetParent !== null) return c;
      }
      return adaylar.length ? adaylar[0] : null;
    }

    /* Tasarima, urun fotografindakiyle ayni oranli duz siyah cerceve cizer. */
    function cerceveEkle(kaynak) {
      var pw = kaynak.width, ph = kaynak.height;
      var t = Math.max(6, Math.round(pw * 0.05));
      var c = document.createElement("canvas");
      c.width = pw + t * 2;
      c.height = ph + t * 2;
      var x = c.getContext("2d");
      x.fillStyle = "#121212";
      x.fillRect(0, 0, c.width, c.height);
      // cercevenin posteri kavradigi ince acik ic hat (derinlik hissi)
      x.strokeStyle = "#484848";
      x.lineWidth = 2;
      x.strokeRect(t - 1, t - 1, pw + 2, ph + 2);
      x.drawImage(kaynak, t, t, pw, ph);
      return c.toDataURL("image/png");
    }

    function gorselYukle(url) {
      return new Promise(function (coz, at) {
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = function () { coz(img); };
        img.onerror = function () { at(new Error("gorsel yuklenemedi")); };
        img.src = url;
      });
    }

    /* Krem studyo zemini uzerindeki cerceveli posteri bulup kirpar. */
    function kirp(img) {
      var W = img.naturalWidth, H = img.naturalHeight;
      var c = document.createElement("canvas");
      c.width = W; c.height = H;
      var x = c.getContext("2d", { willReadFrequently: true });
      x.drawImage(img, 0, 0);

      var kutu = null;
      try {
        var d = x.getImageData(0, 0, W, H).data;
        var zemin = [d[0], d[1], d[2]];
        // 1) siyah cerceve (golge bu esigin ustunde kalir, kirpima girmez)
        kutu = sinirBul(d, W, H, function (r, g, b) {
          return Math.max(r, g, b) < 110;
        });
        // 2) olmadiysa zeminden belirgin farkli her sey
        if (!kutu) {
          kutu = sinirBul(d, W, H, function (r, g, b) {
            return Math.max(Math.abs(r - zemin[0]), Math.abs(g - zemin[1]),
                            Math.abs(b - zemin[2])) > 45;
          });
        }
      } catch (e) {
        kutu = null;   // tuval kirlenmis (CORS) -- gorselin tamami kullanilir
      }

      if (!kutu || kutu.en < W * 0.15 || kutu.boy < H * 0.15) {
        return { url: img.src, oran: W / H };
      }

      var kes = document.createElement("canvas");
      kes.width = kutu.en; kes.height = kutu.boy;
      kes.getContext("2d").drawImage(img, kutu.x0, kutu.y0, kutu.en, kutu.boy,
                                     0, 0, kutu.en, kutu.boy);
      /* BEYAZ CERCEVE (Claude, 13 Eylul 2026) */
      function cpBeyazSecili() {
        var r = document.querySelectorAll('input[type="radio"]:checked');
        for (var i = 0; i < r.length; i++) {
          if ((r[i].value || "").indexOf("Beyaz") === 0) return true;
        }
        return false;
      }
      function cpPaspartuSecili() {
        var k = document.querySelector("[data-cp-paspartu]");
        if (!k) return false;
        return k.checked === true || k.getAttribute("aria-pressed") === "true";
      }
      if (cpBeyazSecili()) {
        var pas = cpPaspartuSecili() ? Math.round(kes.width * 0.08) : 0;
        var kal = Math.max(6, Math.round((kes.width + pas * 2) * 0.05));
        var d = kal + pas;
        var bc = document.createElement("canvas");
        bc.width = kes.width + d * 2;
        bc.height = kes.height + d * 2;
        var bx = bc.getContext("2d");
        bx.fillStyle = "#f1eee8";                       // cerceve govdesi
        bx.fillRect(0, 0, bc.width, bc.height);
        if (pas) {
          bx.fillStyle = "#ffffff";                     // paspartu
          bx.fillRect(kal, kal, bc.width - kal * 2, bc.height - kal * 2);
        }
        // beyaz cerceve acik duvarda kaybolmasin: ince dis hat + ic hat
        bx.strokeStyle = "rgba(92, 80, 66, 0.45)";
        bx.lineWidth = 2;
        bx.strokeRect(1, 1, bc.width - 2, bc.height - 2);
        bx.strokeStyle = "rgba(0, 0, 0, 0.22)";
        bx.lineWidth = 1;
        bx.strokeRect(d - 0.5, d - 0.5, kes.width + 1, kes.height + 1);
        bx.drawImage(kes, d, d);
        try {
          return { url: bc.toDataURL("image/png"), oran: bc.width / bc.height };
        } catch (e) { /* asagidaki eski yola dus */ }
      }
      try {
        return { url: kes.toDataURL("image/png"), oran: kutu.en / kutu.boy };
      } catch (e) {
        return { url: img.src, oran: W / H };
      }
    }

    function sinirBul(d, W, H, test) {
      var x0 = W, y0 = H, x1 = -1, y1 = -1;
      for (var y = 0; y < H; y++) {
        var satir = y * W * 4;
        for (var x = 0; x < W; x++) {
          var i = satir + x * 4;
          if (test(d[i], d[i + 1], d[i + 2])) {
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
          }
        }
      }
      if (x1 < 0 || y1 < 0) return null;
      return { x0: x0, y0: y0, en: x1 - x0 + 1, boy: y1 - y0 + 1 };
    }

    function posterKaynagi() {
      var tuval = tasarimciTuvali();
      if (tuval) {
        try {
          /* data-cp-cerceveli: tuvalde cerceveler ZATEN cizili
             (set kurucusunun kompozisyonu boyle geliyor). Ustune bir
             cerceve daha eklemek butun kompozisyonu tek posterlik bir
             cercevenin icine sokuyordu. */
          if (tuval.hasAttribute("data-cp-cerceveli")) {
            return Promise.resolve({ url: tuval.toDataURL("image/png"),
                                     oran: tuval.width / tuval.height });
          }
          return Promise.resolve({ url: cerceveEkle(tuval), oran: tuval.width / tuval.height });
        } catch (e) { /* asagidaki urun fotografina dus */ }
      }
      /* SECILI GORSEL (Claude, 13 Eylul 2026). data-dg-poster sunucuda
         basilan SABIT kapaktir; musteri Beyaz cerceve ya da paspartu secse
         bile degismiyordu - duvara siyah cerceveli poster bindiriliyordu.
         Galeride O AN GORUNEN ilk gorseli aliyoruz; hangi gorselin dogru
         oldugunu galeri-filtre.js zaten hesapliyor. */
      function cpSeciliGorsel() {
        var kaplar = document.querySelectorAll(
          "ul.media-gallery__grid > li.product-media-container, slideshow-slide");
        for (var i = 0; i < kaplar.length; i++) {
          if (kaplar[i].hasAttribute("data-cp-gizli")) continue;
          var im = kaplar[i].querySelector("img");
          if (!im) continue;
          var s = im.currentSrc || im.src || "";
          if (!s) continue;
          var ad = s.split("/").pop().split("?")[0];
          // duvara asilacak gorsel degiller
          if (ad.indexOf("boyut-karsilastirma") !== -1) continue;
          if (ad.indexOf("closeup") !== -1) continue;
          if (ad.indexOf("lifestyle") !== -1) continue;
          // kartlik kucuk surum duvarda bulanik kalir
          return /([?&])width=\d+/.test(s)
            ? s.replace(/([?&])width=\d+/, "$1width=1400")
            : s + (s.indexOf("?") === -1 ? "?" : "&") + "width=1400";
        }
        return null;
      }
      var url = cpSeciliGorsel() || root.getAttribute("data-dg-poster");
      if (!url) return Promise.reject(new Error("poster gorseli yok"));
      if (KIRPMA_ONBELLEK[url]) return Promise.resolve(KIRPMA_ONBELLEK[url]);
      return gorselYukle(url).then(function (img) {
        var sonuc = kirp(img);
        KIRPMA_ONBELLEK[url] = sonuc;
        return sonuc;
      });
    }

    // ---------------------------------------------------------------
    // Duvar fotografi
    // ---------------------------------------------------------------
    /* Sahne kutusu, duvar fotografiyla BIREBIR ayni olcude yapilir.
       Neden: fotograf `object-fit: cover` ile basiliyor. Kutunun orani fotografin
       oranindan farkli olsaydi fotograf kirpilirdi; `contain` yapsaydik bu sefer
       kenarlarda bos bant kalir ve poster o bantlarin uzerine surüklenebilirdi
       (poster konumu kutuya gore yuzdeyle tutuluyor). Kutuyu fotografla ayni orana
       getirince ikisi de olmuyor: kirpma yok, bant yok, konumlar dogru.

       Genislik panelden, yukseklik pencereden sinirli; hangisi once biterse o
       belirliyor. Boylece dar telefonda ve genis masaustunde ayni kod calisiyor. */
    function sahneyiOlcekle() {
      var oran = wall.naturalWidth / wall.naturalHeight;
      if (!oran || !isFinite(oran)) return;
      var panel = stage.parentNode;
      // Yatay bosluk CSS'ten okunuyor: masaustunde 14px, mobilde 10px.
      // (margin `auto` DEGIL, sabit px -- yoksa ikinci cagride kullanilan
      //  ortalama payini bosluk sanip kutuyu her seferinde kuculturduk.)
      var st = window.getComputedStyle(stage);
      var bosluk = (parseFloat(st.marginLeft) || 0) + (parseFloat(st.marginRight) || 0);
      var kapEn = (panel.clientWidth || 0) - bosluk;
      if (kapEn <= 0) return;
      // Kullanilabilir yukseklik TAHMIN EDILMIYOR, olculuyor: panelin diger
      // parcalari (baslik, araclar, alt not) ne kadar yer kapliyorsa geri kalani
      // sahnenin. Onceden "pencerenin %64'u" deniyordu ve toplam panele sigmayinca
      // flex kutusu sahneyi sikistirip orani bozuyordu (olculdu: 1.340 -> 1.363,
      // yani fotograf hafifce kirpiliyordu).
      var st2 = window.getComputedStyle(stage);
      var dikey = (parseFloat(st2.marginTop) || 0) + (parseFloat(st2.marginBottom) || 0);
      var krom = 0;
      Array.prototype.forEach.call(panel.children, function (el) {
        if (el !== stage) krom += el.getBoundingClientRect().height;
      });
      var pencereBoy = window.innerHeight || 700;             // olculemezse makul varsayilan
      var enBoy = Math.min(pencereBoy - 24 - krom - dikey, 560);
      if (enBoy < 160) enBoy = 160;                           // cok kisa ekranda panel kayar
      var en = Math.min(kapEn, enBoy * oran);
      stage.style.width = Math.round(en) + "px";
      stage.style.height = Math.round(en / oran) + "px";
      stage.style.maxHeight = "none";
      stage.style.minHeight = "0";
      // Kutu panelden dar kalabilir; ortalansin. (Bos durumda `stretch` kalir ki
      // yukleme kutusu panelin tam genisligini kaplasin.)
      stage.style.alignSelf = "center";
    }

    var olcekZaman = null;
    window.addEventListener("resize", function () {
      if (wall.hidden) return;
      clearTimeout(olcekZaman);
      olcekZaman = setTimeout(sahneyiOlcekle, 120);
    });

    function duvariAyarla(file) {
      if (!file || !/^image\//.test(file.type)) {
        hataGoster("Lütfen bir fotoğraf seç (JPG veya PNG).");
        return;
      }
      hataGoster("");
      if (duvarUrl) URL.revokeObjectURL(duvarUrl);
      duvarUrl = URL.createObjectURL(file);
      wall.onload = function () {
        sahneyiOlcekle();
        wall.hidden = false;
        drop.hidden = true;
        tools.hidden = false;
        posteriGoster();
      };
      wall.onerror = function () { hataGoster("Bu fotoğraf açılamadı, başka bir tane dener misin?"); };
      wall.src = duvarUrl;
    }

    function posteriGoster() {
      posterKaynagi().then(function (p) {
        poster.src = p.url;
        poster.hidden = false;
        poster.style.width = slider.value + "%";
        poster.style.left = "50%";
        poster.style.top = "42%";
      }).catch(function () {
        hataGoster("Poster görseli hazırlanamadı. Sayfayı yenileyip tekrar dener misin?");
      });
    }

    function hataGoster(metin) {
      if (!hata) return;
      hata.textContent = metin;
      hata.hidden = !metin;
    }

    dosya.addEventListener("change", function () {
      if (dosya.files && dosya.files[0]) duvariAyarla(dosya.files[0]);
    });

    if (degistir) degistir.addEventListener("click", function () { dosya.click(); });
    drop.addEventListener("click", function () { dosya.click(); });

    // Surukleyip birakma
    ["dragenter", "dragover"].forEach(function (t) {
      drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.add("dg-uzerinde"); });
    });
    ["dragleave", "drop"].forEach(function (t) {
      drop.addEventListener(t, function (e) { e.preventDefault(); drop.classList.remove("dg-uzerinde"); });
    });
    drop.addEventListener("drop", function (e) {
      var f = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
      if (f) duvariAyarla(f);
    });

    // ---------------------------------------------------------------
    // Posteri surukle / boyutlandir
    // ---------------------------------------------------------------
    var tutus = null;

    poster.addEventListener("pointerdown", function (e) {
      var k = stage.getBoundingClientRect();
      tutus = {
        id: e.pointerId,
        dx: e.clientX - (k.left + (parseFloat(poster.style.left) / 100) * k.width),
        dy: e.clientY - (k.top + (parseFloat(poster.style.top) / 100) * k.height)
      };
      poster.setPointerCapture(e.pointerId);
      poster.classList.add("dg-tutuluyor");
      e.preventDefault();
    });

    poster.addEventListener("pointermove", function (e) {
      if (!tutus || e.pointerId !== tutus.id) return;
      var k = stage.getBoundingClientRect();
      var x = ((e.clientX - tutus.dx - k.left) / k.width) * 100;
      var y = ((e.clientY - tutus.dy - k.top) / k.height) * 100;
      poster.style.left = Math.min(100, Math.max(0, x)) + "%";
      poster.style.top = Math.min(100, Math.max(0, y)) + "%";
    });

    ["pointerup", "pointercancel"].forEach(function (t) {
      poster.addEventListener(t, function () {
        tutus = null;
        poster.classList.remove("dg-tutuluyor");
      });
    });

    // Klavyeyle de tasinabilsin (erisilebilirlik)
    poster.setAttribute("tabindex", "0");
    poster.addEventListener("keydown", function (e) {
      var adim = e.shiftKey ? 5 : 1;
      var l = parseFloat(poster.style.left) || 50;
      var t = parseFloat(poster.style.top) || 42;
      if (e.key === "ArrowLeft") l -= adim;
      else if (e.key === "ArrowRight") l += adim;
      else if (e.key === "ArrowUp") t -= adim;
      else if (e.key === "ArrowDown") t += adim;
      else return;
      e.preventDefault();
      poster.style.left = Math.min(100, Math.max(0, l)) + "%";
      poster.style.top = Math.min(100, Math.max(0, t)) + "%";
    });

    slider.addEventListener("input", function () {
      poster.style.width = slider.value + "%";
    });

    // ---------------------------------------------------------------
    // Ac / kapat
    // ---------------------------------------------------------------
    function ac() {
      acanOge = document.activeElement;
      modal.hidden = false;
      document.body.style.overflow = "hidden";
      // Duvar zaten secilmisse posteri tazele (tasarim degismis olabilir)
      if (!wall.hidden) posteriGoster();
      var odak = wall.hidden ? drop : poster;
      if (odak && odak.focus) odak.focus();
    }

    function kapat() {
      modal.hidden = true;
      document.body.style.overflow = "";
      if (acanOge && acanOge.focus) acanOge.focus();
    }

    trigger.addEventListener("click", ac);
    root.querySelectorAll("[data-dg-close]").forEach(function (b) {
      b.addEventListener("click", kapat);
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !modal.hidden) kapat();
    });
  });
})();
